if (!customElements.get("draw-text")) {
	customElements.define(
		"draw-text",
		class DrawText extends HTMLElement {
			constructor() {
				super();
				this.strongs = [];
				this.svgElements = [];
				this.observer = null;
			}

			connectedCallback() {
				setTimeout(() => {
					this.init();
				}, 0);
			}

			init() {
				this.strongs = this.querySelectorAll("strong");

				if (this.strongs.length === 0) return;

				this.createSVGElements();
				this.setupScrollObserver();
			}

			createSVGElements() {
				this.strongs.forEach((strong, index) => {
					const svg = document.createElementNS(
						"http://www.w3.org/2000/svg",
						"svg"
					);
					const path = document.createElementNS(
						"http://www.w3.org/2000/svg",
						"path"
					);

					path.setAttribute("fill", "none");
					path.setAttribute("stroke", "rgb(var(--advanced-display-color))");
					path.setAttribute("stroke-width", "5");
					path.setAttribute("stroke-linecap", "butt");
					path.setAttribute("stroke-linejoin", "round");
					path.setAttribute("pathLength", "1");
					path.setAttribute("stroke-dasharray", "0 1");
					path.style.transition = "stroke-dasharray 1.2s ease-out";

					svg.appendChild(path);
					strong.appendChild(svg);

					this.svgElements.push({ svg, path, strong });
				});
			}

			setupScrollObserver() {
				const options = {
					root: null,
					rootMargin: "-20px",
					threshold: 0.8,
				};

				this.observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						const strong = entry.target;
						const svgData = this.svgElements.find(
							(item) => item.strong === strong
						);

						if (svgData) {
							if (entry.isIntersecting) {
								this.animateHandDrawnUnderline(svgData, true);
							} else {
								this.animateHandDrawnUnderline(svgData, false);
							}
						}
					});
				}, options);

				this.strongs.forEach((strong) => {
					this.observer.observe(strong);
				});
			}

			generateHandDrawnUnderlinePath(width) {
				const padding = 6;
				const w = width + padding * 2;

				const originalWidth = 207;
				const originalHeight = 13;

				const scaleX = w / originalWidth;
				const scaleY = Math.min(scaleX, 1);

				const originalPath =
					"M3 10.4291C45.3333 5.42912 144.8 -2.07088 204 7.92912";

				const transformPath = (pathStr) => {
					return pathStr.replace(/([0-9.-]+)\s+([0-9.-]+)/g, (match, x, y) => {
						const newX = parseFloat(x) * scaleX;
						const newY = parseFloat(y) * scaleY;
						return `${newX} ${newY}`;
					});
				};

				return {
					path: transformPath(originalPath),
					width: w,
					height: originalHeight * scaleY,
				};
			}

			animateHandDrawnUnderline(svgData, isVisible) {
				const { svg, path, strong } = svgData;

				if (isVisible) {
					const rect = strong.getBoundingClientRect();
					const width = rect.width;

					const pathData = this.generateHandDrawnUnderlinePath(width);

					svg.setAttribute("width", pathData.width);
					svg.setAttribute("height", pathData.height);
					svg.setAttribute(
						"viewBox",
						`0 0 ${pathData.width} ${pathData.height}`
					);

					path.setAttribute("d", pathData.path);

					requestAnimationFrame(() => {
						path.setAttribute("stroke-dasharray", "1 0");
					});
				} else {
					path.setAttribute("stroke-dasharray", "0 1");
				}
			}

			disconnectedCallback() {
				if (this.observer) {
					this.observer.disconnect();
				}
			}
		}
	);
}
